/**
 * Originals domain — fetchers and mutations over the player-JWT gateway.
 */
import { apiFetch } from '../../lib/api/client.js';
import type {
  ActiveSeed,
  OriginalsConfig,
  ParamValue,
  PlayEnvelope,
  PlayRequest,
  RotateResult,
  VerifyResult,
} from './types.js';

export function getOriginalsConfig(
  code: string,
  params?: Record<string, ParamValue>,
): Promise<OriginalsConfig> {
  const qs = params
    ? '?' +
      new URLSearchParams(
        Object.fromEntries(Object.entries(params).map(([k, v]) => [k, String(v)])),
      ).toString()
    : '';
  return apiFetch<OriginalsConfig>(`/originals/games/${encodeURIComponent(code)}${qs}`);
}

export function playOriginals(body: PlayRequest): Promise<PlayEnvelope> {
  return apiFetch<PlayEnvelope>('/originals/play', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export function getActiveSeed(): Promise<ActiveSeed> {
  return apiFetch<ActiveSeed>('/originals/seed/active');
}

export function rotateSeed(clientSeed?: string): Promise<RotateResult> {
  return apiFetch<RotateResult>('/originals/seed/rotate', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ clientSeed }),
  });
}

export function verifyRound(roundId: string): Promise<VerifyResult> {
  return apiFetch<VerifyResult>(`/originals/verify?roundId=${encodeURIComponent(roundId)}`);
}
